export default "__VITE_ASSET__CyZ1v7NW__"